import styled from 'styled-components'

export const ContainerSingleSelect = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  & > .multi-select-component {
    width: 100%;
  }
`

export const ContainerScrollProducts = styled.div`
  padding: 8px 16px;
  max-height: 300px;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
`

export const buttonChangeStop: React.CSSProperties = {
  display: 'flex',
  padding: '1px 8px',
  alignItems: 'center',
  gap: '6px',
  borderRadius: '12px',
  backgroundColor: '#F3F5F9',
  width: '30%'
}

export const defaultStylesCardWrapper: React.CSSProperties = {
  borderRadius: '8px',
  border: '1px solid #F3F5F9',
  padding: '10px 12px'
}

export const containerBody: React.CSSProperties = {
  marginTop: '16px',
  marginBottom: '16px',
  height: 'auto'
}

export const ContainerScroll = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  overflow: auto;
`
